import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';

class OptimizationPipelineService extends GenericTableService {
	constructor() {
		super();

		this.CONTROL = 'optimizationPipelineControl';
	}

	/**
	  * @return {Promise<NamedDto[]>}
	  */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new OptimizationPipelineService();
